import { useCallback, useMemo, useState } from 'react';
import moment from 'moment';
import Axios from 'supports/api';

const today = new Date();
const defaultFromDate = new Date(today.getFullYear(), today.getMonth(), 1);

const emptySummary = { grandTotalInvoice: 0, grandTotalPayment: 0 };

const useAccountingSalesReport = () => {
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [toDate, setToDate] = useState(today);
  const [rawRows, setRawRows] = useState([]);
  const [summary, setSummary] = useState(emptySummary);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchReport = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await Axios.get('/v2/payment/accounting-sales-report', {
        params: {
          fromDate: moment(fromDate).format('YYYY-MM-DD'),
          toDate: moment(toDate).format('YYYY-MM-DD'),
        },
      });
      setRawRows(Array.isArray(data?.result) ? data.result : []);
      setSummary(data?.summary || emptySummary);
    } catch (err) {
      setError(err);
      setRawRows([]);
      setSummary(emptySummary);
    } finally {
      setLoading(false);
    }
  }, [fromDate, toDate]);

  const filteredRows = useMemo(() => {
    if (!rawRows.length) return [];
    const from = moment(fromDate).startOf('day');
    const to = moment(toDate).endOf('day');
    return rawRows.filter((row) => {
      const ref = row?.invoiceCreatedAt;
      if (!ref) return false;
      return moment(ref).isBetween(from, to, undefined, '[]');
    });
  }, [rawRows, fromDate, toDate]);

  return {
    fromDate,
    toDate,
    setFromDate,
    setToDate,
    rawRows,
    filteredRows,
    summary,
    loading,
    error,
    fetchReport,
  };
};

export default useAccountingSalesReport;
